import { FieldMeta } from '@/modules/dynamic-form/models/FieldMeta.model';
import { FieldSchema } from '@/modules/dynamic-form/models/FieldSchema.model';

import { toFieldPath } from '../../to-field-path/toFieldPath';

// FieldMeta definitions for each property
const SCHEDULED_OR_BLANKET_TYPE_META: FieldMeta = {
    path: toFieldPath('type'),
    label: 'Type',
    type: {
        $type: 'StringBoolean',
        trueValue: 'SCHEDULED',
        falseValue: 'BLANKET',
        trueLabel: 'Scheduled',
        falseLabel: 'Blanket',
    } as any,
    required: true,
    defaultValue: 'SCHEDULED',
};

const SCHEDULED_INSURED_NAMES_META: FieldMeta = {
    path: toFieldPath('names'),
    label: 'Scheduled Insured Names',
    type: {
        $type: 'List',
        elementType: {
            $type: 'String',
        },
    },
    required: false,
    defaultValue: [],
};

const properties = {
    type: SCHEDULED_OR_BLANKET_TYPE_META,
    names: SCHEDULED_INSURED_NAMES_META,
};

const defaultValue = {
    type: 'SCHEDULED',
    names: [],
};

export function createScheduledOrBlanketFieldMeta(schema: FieldSchema): FieldMeta {
    return { ...schema, properties, defaultValue };
}
